import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "textarea-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "image"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["placeholder"]
const _hoisted_5 = { class: "area-actions" }
const _hoisted_6 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_app_file_uploader = _resolveComponent("app-file-uploader")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: _normalizeClass(["area-image", { fly: _ctx.urlRef }])
    }, [
      (_ctx.urlRef)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _ctx.urlRef,
              alt: "image"
            }, null, 8, _hoisted_3),
            _createElementVNode("div", {
              class: "icon",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clearImage && _ctx.clearImage(...args)))
            }, [
              _createVNode(_component_font_awesome_icon, {
                size: "sm",
                icon: ['fas', 'fa-times']
              })
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _withDirectives(_createElementVNode("textarea", {
      id: "textarea",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.textareaRef) = $event)),
      placeholder: _ctx.t('writeSomething'),
      class: "textarea__field",
      onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleBlur && _ctx.handleBlur(...args))),
      onFocus: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.focus && _ctx.focus(...args)))
    }, null, 40, _hoisted_4), [
      [_vModelText, _ctx.textareaRef]
    ]),
    _cache[4] || (_cache[4] = _createElementVNode("span", { class: "focus-input100" }, null, -1)),
    _createElementVNode("section", _hoisted_5, [
      _createVNode(_component_app_file_uploader, {
        "is-show-sign": false,
        "is-title": false,
        onSelect: _ctx.onFileSelected
      }, null, 8, ["onSelect"]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_app_button, {
          severity: "secondary",
          icon: ['fas', 'arrow-up'],
          raised: "",
          loading: _ctx.loader,
          onClick: _ctx.apply
        }, null, 8, ["loading", "onClick"])
      ])
    ])
  ]))
}